import React from 'react';
import {
  Box,
  Flex,
  PaginationProvider,
  SortProvider,
  SearchProvider,
  ITableFilter,
  ModalProvider,
  FormProvider,
} from 'dash-ui';
import OrganizationUsersTableHeader from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/OrganizationUsersTableHeader/OrganizationUsersTableHeader';
import OrganizationUsersTable from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/OrganizationUsersTable/OrganizationUsersTable';
import SaveOrganizationUsersModal from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/SaveOrganizationUsersModal/SaveOrganizationUsersModal';
import { FormFieldsList } from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/SaveOrganizationUsersModal/constants/constants';
import SendRegistrationLinkToUserModal from './components/SendRegistrationLinkToUserModal/SendRegistrationLinkToUserModal';
import SetOrganizationUserStatusModal from './components/SetOrganizationUserStatsModal/SetOrganizationUserStatusModal';
import DeleteOrganizationUserModal from './components/DeleteOrganizationUserModal/DeleteOrganizationUserModal';

function OrganizationUsers({ filter }: { filter: ITableFilter }) {
  return (
    <Box>
      <PaginationProvider>
        <SortProvider>
          <SearchProvider>
            <ModalProvider>
              <Flex flexDirection="column" flex={1} w="100%">
                <OrganizationUsersTableHeader />
                <OrganizationUsersTable filter={filter} />
                <FormProvider fieldsList={FormFieldsList}>
                  <SaveOrganizationUsersModal
                    organizationId={filter.organizationId || ''}
                  />
                </FormProvider>
                <SendRegistrationLinkToUserModal />
                <SetOrganizationUserStatusModal />
                <DeleteOrganizationUserModal />
              </Flex>
            </ModalProvider>
          </SearchProvider>
        </SortProvider>
      </PaginationProvider>
    </Box>
  );
}

export default OrganizationUsers;
